import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-basic-coverage-form',
  templateUrl: './basic-coverage-form.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class TechnicalInstallationBasicCoverageFormComponent
  implements OnInit, OnDestroy
{
  @Input()
  formGroup!: FormGroup;

  @Input()
  name: string = '';

  private subscription?: Subscription;

  get isCovered(): boolean {
    if (!this.formGroup) return false;
    const covered = this.formGroup.controls['covered']?.value;
    return covered === true || covered === 'true';
  }

  ngOnInit(): void {
    // Subscribe to covered field changes to reset dependent fields when covered is false/null
    if (!this.formGroup) return;
    const coveredControl = this.formGroup.controls['covered'];
    if (coveredControl) {
      this.subscription = coveredControl.valueChanges.subscribe(
        (value: boolean | string | null) => {
          if (value !== true && value !== 'true') {
            this.formGroup.controls['insuredSum']?.reset();
            this.formGroup.controls['deductible']?.reset();
          }
        }
      );
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
